import { axiosClient } from "./axiosClient"

export const ACCOUNT_PATH = '/api/v1/account'

export const addAccount = (body) => {
    return axiosClient.post(ACCOUNT_PATH, body)
}

export const updateAccount = (id, body) => {
    return axiosClient.put(`${ACCOUNT_PATH}/${id}`, body)
}

export const deleteAccount = (id) => {
    return axiosClient.delete(`${ACCOUNT_PATH}/${id}`)
}

export const getAccountById = (id) => {
    return axiosClient.get(`${ACCOUNT_PATH}/${id}`)
}

export const getPageAccounts = ({ search = '', lastId = '', id = "", code = '', name = '' }) => {
    return axiosClient.get(`${ACCOUNT_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
}